import type { CoinDetailType } from "types/prices";

export const CoinTypes = [
  "memecoin",
  "stablecoin",
  "wrappedcoin",
  "paxGold"
] as const;

export type CoinType = (typeof CoinTypes)[number];

export function getCoinType(coinDetails: CoinDetailType): CoinType | undefined {
  if (coinDetails.coin === "PAXG") {
    return "paxGold";
  }
  if (coinDetails.isMemeCoin) {
    return "memecoin";
  }
  if (coinDetails.isStableCoin) {
    return "stablecoin";
  }
  if (coinDetails.isWrappedCoin) {
    return "wrappedcoin";
  }

  return;
}
